module.exports = __webpack_public_path__ + "fonts/effect-miss-38e043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-miss.svg
// module id = 793
// module chunks = 0